import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService } from 'app/services';
import { Subscription } from 'rxjs';
import { ScriptLoaderService } from 'app/services/script-loader.service';
import { config } from 'app/constants';

@Component({
  selector: 'app-payrix-payment-field',
  templateUrl: './payrix-payment-field.component.html',
  styleUrls: ['./payrix-payment-field.component.scss'],
  providers: [DialogService],
})
export class PayrixPaymentFieldComponent implements OnInit {
  @ViewChild('closeDiv') myDiv: ElementRef<HTMLElement>;

  dataServiceSubscription: Subscription;
  win: any;
  payRixResponse: {};
  payment: any = {};
  orderVehicle: any = {};
  isProcessing = true;
  isSubmitting = false;
  company: any = {};
  redirect = config.redirectUrl.privacyAndSecurity;
  zip: string = '';
  merchantId: string = '';
  apiKey: string = '';
  invoiceCode: string = '';
  usdPayment: string = '';
  companyInput;
  payrixErrorMsg: string = '';

  constructor(
    public dataService: DataService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private scriptLoader: ScriptLoaderService,
    private helperService: HelperService,
    private httpService: HTTPService
  ) {}

  ngOnInit() {
    const data = this.dConfig.data;

    if (data) {
      this.payment = data.payment;
      this.merchantId = data.merchantId;
      this.apiKey = data.apiKey;
      this.companyInput = data.company;
      this.orderVehicle = data.orderVehicle;
      if (!this.payment.collectedAmount) {
        this.payment.collectedAmount = Number(this.payment.total.unpaid).toFixed(2);
      } else {
        this.payment.collectedAmount = Number(this.payment.collectedAmount).toFixed(2);
      }
      this.usdPayment = this.payment.collectedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    this.loadpayRix().then(() => {
      this.isProcessing = false;

      this.setDataService();
    });
  }

  setDataService() {
    if (this.companyInput) {
      this.company = this.companyInput;
      return;
    }

    this.company = this.dataService.company;
  }

  closePaymentModal(isSuccess: boolean, data: any) {
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    this.ref.close({ isSuccess, data: data });
    this.triggerFalseClick();
  }

  //  load payRix script
  async loadpayRix() {
    const res = await this.scriptLoader.loadScript('payFieldScript').then((r: any) => {
      this.win = window;

      if (r.status === 'Already Loaded') {
        this.win.PayFields.reload();
      }

      this.win.PayFields.fields = [
        { type: 'number', element: '#number' },
        { type: 'cvv', element: '#cvv' },
        { type: 'name', element: '#name' },
        { type: 'expiration', element: '#expiration' },
      ];

      this.win.PayFields.config.merchant = this.merchantId;
      this.win.PayFields.config.apiKey = this.apiKey;

      this.win.PayFields.config.amount = (this.payment.collectedAmount * 100).toFixed(2);
      this.win.PayFields.buttonAmount = (this.payment.collectedAmount * 100).toFixed(2);
      this.win.PayFields.button = { element: '#submit', value: 'pay' };
      this.win.PayFields.customizations = {
        style: {
          '.input': {
            height: '30px',
            width: '100%',
            borderColor: 'var(--secondary-100)',
            color: '#0c0d0d',
            fontSize: '14px',
          },
        },
      };
      this.win.PayFields.customizations.placeholders = {
        '#expiration': 'MM/YY',
        '#name': 'cardholder name',
      };

      this.win.PayFields.onValidationFailure = () => {
        this.isSubmitting = false;
      };

      this.win.PayFields.onSuccess = (successResponse) => {
        this.helperService.showToaster('success', 'Payment successful');
        //  after success call create API and save transaction\
        this.isSubmitting = false;
        this.closePaymentModal(true, successResponse);
      };

      this.win.PayFields.onFailure = (err) => {
        let error = err.errors;
        console.log(error);
        this.isSubmitting = false;
        if (error.length) {
          error = error[0].msg;
          this.payrixErrorMsg = error;
        }
      };
    });
    return res;
  }

  triggerFalseClick() {
    const el: HTMLElement = this.myDiv.nativeElement;
    el.click();
  }

  zipChange(data) {
    this.zip = data;
  }

  async payRixAPI() {
    if (!this.zip) {
      return;
    }
    this.isSubmitting = true;
    this.payrixErrorMsg = '';

    // refetch estiamate
    if (this.payment && this.payment.estimate && this.payment.estimate.estimateId) {
      try {
        const data = await this.httpService.getEstimateById(this.payment.estimate.estimateId);
        if (data) {
          if (data.total.unpaid < Number(this.payment.estimate.unpaid)) {
            this.payrixErrorMsg = 'Amount must be lesser than remaining balance.';
            return;
          }
        }
      } catch (err) {
        this.isSubmitting = false;
        this.helperService.showToaster('error', err);
      }
    }

    try {
      this.invoiceCode = (this.payment.estimate && this.payment.estimate.invCode) || '';
      this.win.PayFields.config.order = `RO:${this.payment.code} ${this.invoiceCode ? `/ Invoice:${this.invoiceCode}` : ''}`;
      this.win.PayFields.config.additionalData = {
        description: `${this.payment.customer ? this.payment.customer.fullName || this.payment.customer.displayName : ''} | ${this.orderVehicle ? this.orderVehicle.name : ''}`,
      };
      this.win.PayFields.config.billingAddress = {
        zip: this.zip,
        company: this.company.name,
      };
      this.win.PayFields.submit();
    } catch (e) {
      this.helperService.showToaster('error', e);
    }
  }
}
